import { Reveal } from "./Reveal";
import { Globe, Network, ShieldCheck, Handshake, Eye, Scale, Users, FileText } from "lucide-react";

const ITEMS = [
  [Globe, "Europe-focused expertise", "Deep knowledge of European labour markets and hiring norms."],
  [Network, "International recruitment network", "A vetted network sourcing talent across borders."],
  [ShieldCheck, "Structured candidate screening", "Consistent identity, qualification and experience checks."],
  [Handshake, "B2B recruitment partnerships", "Reliable cooperation with agencies and employers."],
  [Eye, "Transparent process", "Clear information for employers and candidates at every step."],
  [Scale, "Compliance-focused approach", "Documentation and permits handled the right way."],
  [Users, "Employer & candidate support", "Support for both sides, before and after deployment."],
  [FileText, "Professional documentation", "Careful contract and document preparation and review."],
];

export const WhyUs = () => (
  <section id="why" data-testid="why-section" className="py-24 md:py-32 px-6 md:px-12">
    <div className="max-w-[1600px] mx-auto">
      <Reveal>
        <p className="font-body text-sm tracking-[0.25em] uppercase text-[#ff3b30] mb-6">
          Why Daab Recruitment
        </p>
        <h2 className="font-head uppercase tracking-tighter leading-[0.9] text-5xl md:text-7xl xl:text-8xl mb-16 md:mb-20">
          Trust, by
          <br />
          design.
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 border-t border-l border-[#e4e4e7]">
        {ITEMS.map(([Icon, title, body], i) => (
          <Reveal key={title} delay={(i % 4) * 0.06} className="border-b border-r border-[#e4e4e7]">
            <div data-testid={`why-${i}`} className="h-full p-8 group hover:bg-[#f4f4f5] transition-colors duration-400">
              <Icon size={28} className="text-[#ff3b30] mb-6" strokeWidth={1.5} />
              <h3 className="font-head uppercase tracking-tight text-xl mb-3">{title}</h3>
              <p className="font-body text-sm text-[#52525b] leading-relaxed">{body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
